// Step6PriceSetting.tsx
import React from "react";

interface Step6PriceSettingProps {
  price: number;
  setPrice: React.Dispatch<React.SetStateAction<number>>;
  discountEnabled: boolean;
  setDiscountEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  discountRate: number;
  setDiscountRate: React.Dispatch<React.SetStateAction<number>>;
  agreeToDiscount: boolean;
  setAgreeToDiscount: React.Dispatch<React.SetStateAction<boolean>>;
  setApplyDiscountToStoreEvents: React.Dispatch<React.SetStateAction<boolean>>;
  errors: { [key: string]: string };
}

const Step6PriceSetting: React.FC<Step6PriceSettingProps> = ({
                                                               price,
                                                               setPrice,
                                                               discountEnabled,
                                                               setDiscountEnabled,
                                                               discountRate,
                                                               setDiscountRate,
                                                               agreeToDiscount,
                                                               setAgreeToDiscount,

                                                               setApplyDiscountToStoreEvents,
                                                               errors,
                                                             }) => {
  const finalPrice = discountEnabled ? price - (price * discountRate) / 100 : price;

  // Format number with commas
  const formatNumber = (num: number) => {
    return new Intl.NumberFormat('ko-KR').format(num);
  };

  return (
    <div className="w-full">
      {/* 상품 가격 입력 */}
      <label htmlFor="price" className="block text-sm font-medium text-gray-700">
        상품 가격 <span className="text-red-500">*</span>
      </label>
      <input
        type="number"
        id="price"
        value={price}
        onChange={(e) => setPrice(parseFloat(e.target.value) || 0)}
        className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm ${
          errors.price ? "border-red-500" : ""
        }`}
        placeholder="상품 가격을 입력하세요."
        min="0"
      />
      {errors.price && (
        <p className="mt-2 text-sm text-red-600" id="price-error">
          {errors.price}
        </p>
      )}

      {/* 할인 적용 체크박스 */}
      <div className="mt-4 flex items-center">
        <input
          type="checkbox"
          id="discountEnabled"
          checked={discountEnabled}
          onChange={(e) => setDiscountEnabled(e.target.checked)}
          className="h-4 w-4 text-indigo-600 border-gray-300 rounded"
        />
        <label htmlFor="discountEnabled" className="ml-2 block text-sm text-gray-700">
          할인 적용
        </label>
      </div>

      {/* 할인율 입력 및 추가 옵션 */}
      {discountEnabled && (
        <>
          {/* 할인율 입력 */}
          <div className="mt-4">
            <label htmlFor="discountRate" className="block text-sm font-medium text-gray-700">
              할인율 (%) <span className="text-red-500">*</span>
            </label>
            <input
              type="number"
              id="discountRate"
              value={discountRate}
              onChange={(e) => {
                const value = parseFloat(e.target.value);
                setDiscountRate(isNaN(value) ? 0 : value);
              }}
              className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm ${
                errors.discountRate ? "border-red-500" : ""
              }`}
              placeholder="할인율을 입력하세요."
              min="0"
              max="100"
              required
            />
            {errors.discountRate && (
              <p className="mt-2 text-sm text-red-600" id="discountRate-error">
                {errors.discountRate}
              </p>
            )}
          </div>

          {/* 크릿 이벤트 할인 동의 체크박스 */}
          <div className="mt-4 flex items-center">
            <input
              type="checkbox"
              id="agreeToDiscount"
              checked={agreeToDiscount}
              onChange={(e) => setAgreeToDiscount(e.target.checked)}
              className="h-4 w-4 text-indigo-600 border-gray-300 rounded"
            />
            <label htmlFor="agreeToDiscount" className="ml-2 block text-sm text-gray-700">
              크릿 이벤트에 상품 할인 동의
            </label>
          </div>
        </>
      )}

      {/* 가격 및 최종 가격 표시 */}
      <div className="mt-4">
        <p className="text-sm text-gray-700">
          상품 가격: <span className="font-medium">{formatNumber(price)} 원</span>
        </p>
        <p className="text-sm text-gray-700">
          최종 가격: <span className="font-medium">{formatNumber(finalPrice)} 원</span>
        </p>
      </div>
    </div>
  );
};

export default Step6PriceSetting;
